import {useMemo} from 'react';
import {usePage} from '../contexts/PageContext';

export const useBlockProps = (data) => {
  const {viewport} = usePage();
  return useMemo(() => {
    const blockProps = {
      ...data,
      viewport,
    };

    delete blockProps.blocks;

    return {blockProps};
  }, [data, viewport]);
};
